import dayjs from 'dayjs';
import { LocalStorage } from 'utils';
import { STORAGE_KEY_ENUM } from 'enums';

const renderFormattedDate = (date: string | dayjs.Dayjs | null, hourDetails = false) => {
  if (!date) return '';

  const language = LocalStorage.getItem(STORAGE_KEY_ENUM.LANGUAGE) || 'tr';

  if (!hourDetails) return dayjs(date).format(language === 'tr' ? 'DD.MM.YYYY' : 'MM/DD/YYYY');

  return dayjs(date).format(language === 'tr' ? 'DD.MM.YYYY - HH:mm' : 'MM/DD/YYYY - HH:mm');
};

export default renderFormattedDate;
